/* eslint-disable react/jsx-pascal-case */
import React, { Component }  from 'react';
import { Nav, Navbar, NavbarToggler, Collapse, NavItem, Jumbotron, Button, Modal, ModalHeader, ModalBody, Label, Col, Row } from 'reactstrap';
import { NavLink, Link } from 'react-router-dom';
import LocateUs from './LocateUsComponent';
import { Control, LocalForm, Errors } from 'react-redux-form';


const required = val => val && val.length;
const maxLength = len => val => !val || (val.length <= len);
const minLength = len => val => val && (val.length >= len);
const validEmail = val => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val);

class Header extends Component {
    constructor(props) {
        super (props)
        this.state = {
             isNavOpen: false,
             isModal1Open: false,
             isModal2Open: false,
             isModal3Open: false
        };
        this.toggleNav = this.toggleNav.bind(this);
        this.toggleModal1 = this.toggleModal1.bind(this);
        this.toggleModal2 = this.toggleModal2.bind(this);
        this.toggleModal3 = this.toggleModal3.bind(this);
    }  

    toggleNav() {
        this.setState({
            isNavOpen: !this.state.isNavOpen
        });
    }

    toggleModal1() {
        this.setState({
         isModal1Open: !this.state.isModal1Open
        });
    }

    toggleModal2() {
        this.setState({
         isModal2Open: !this.state.isModal2Open
        });
    }

    toggleModal3() {
        this.setState({
         isModal3Open: !this.state.isModal3Open
        });
    }

    handleSubmit1(values) {
        alert("Current state for Get Quote is: " + JSON.stringify(values));
        this.toggleModal1();        
    }

    handleSubmit2(values) {
        alert("Current state for Request a Visit is: " + JSON.stringify(values));
        this.toggleModal2();        
    }

    handleSubmit3(values) {
        this.toggleModal3();        
    }

    callUs() {
        window.location.href='tel:19546968255';
    }

    render() {
        return (
            <React.Fragment>
                <Jumbotron fluid>
                <div className="container">
                    <div className="row row-content align-items-center">
                        <div className="col-sm-12 col-md-6">
                            <img src="/assets/images/logo.png" className="img-fluid" alt="Logo"/>
                        </div>        
                        <div className="col-sm-12 col-md-3">
                            <Button outline onClick={this.toggleModal1} id="getAQuoteButton" className="btn btn-lg">Get a Quote!</Button>
                        </div>
                        <div className="col-sm-12 col-md-3">
                            <Button outline onClick={this.toggleModal2} id="requestAVisitButton" className="btn btn-lg">Request a Visit!</Button>
                        </div>
                    </div>            
                </div>
                <Modal id="getAQuoteModal" isOpen={this.state.isModal1Open} toggle={this.state.toggle1Modal}>
                    <ModalHeader toggle={this.toggleModal1}>
                        Get a quote from us!
                    </ModalHeader>
                    <ModalBody>
                    <LocalForm onSubmit={values => this.handleSubmit1(values)}>                            
                            <Row className="form-group">
                                <Label htmlFor="name" md={4}>Name</Label>
                                <Col md={12}>
                                    <Control.text model=".name" id="name" name="name"
                                        placeholder="Enter name"
                                        className="form-control"
                                        validators={{
                                            required,
                                            minLength: minLength(2),
                                            maxLength: maxLength(15),                                            
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".name"
                                        show="touched"
                                        component="div"
                                        messages={{
                                            required: 'Required',
                                            minLength: 'Must be at least 2 characters',
                                            maxLength: 'Must be 15 characters or less',                                           
                                        }}
                                    />
                                </Col>
                            </Row>                             
                            <Row className="form-group">
                                <Label htmlFor="email" md={4}>Email</Label>
                                <Col md={12}>
                                    <Control.text model=".email" id="email" name="email"
                                        placeholder="Enter email address"
                                        className="form-control"
                                        validators={{
                                            required,
                                            validEmail
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".email"
                                        show="touched"
                                        component="div"
                                        messages={{
                                            required: 'Required',
                                            validEmail: 'Invalid email address'
                                        }}
                                    />
                                </Col>
                            </Row>                         
                            <Row className="form-group">
                                <Col md={{size: 12, offset: 0}}>
                                    <Button type="submit" color="primary">
                                        Send quote request
                                    </Button>
                                </Col>
                            </Row>
                        </LocalForm>
                    </ModalBody>               
                </Modal>
                <Modal id="getAQuoteModal" isOpen={this.state.isModal2Open} toggle={this.state.toggle2Modal}>
                    <ModalHeader toggle={this.toggleModal2}>
                        Request a Site Visit!
                    </ModalHeader>
                    <ModalBody>
                    <LocalForm onSubmit={values => this.handleSubmit2(values)}>                            
                            <Row className="form-group">
                                <Label htmlFor="name" md={4}>Name</Label>
                                <Col md={12}>
                                    <Control.text model=".name" id="name" name="name"
                                        placeholder="Enter name"
                                        className="form-control"
                                        validators={{
                                            required,
                                            minLength: minLength(2),
                                            maxLength: maxLength(15),                                            
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".name"
                                        show="touched"
                                        component="div"
                                        messages={{
                                            required: 'Required',
                                            minLength: 'Must be at least 2 characters',
                                            maxLength: 'Must be 15 characters or less',                                           
                                        }}
                                    />
                                </Col>
                            </Row>    
                            <Row className="form-group">
                                <Label htmlFor="address" md={4}>Address</Label>
                                <Col md={12}>
                                    <Control.text model=".address" id="address" name="address"
                                        placeholder="Enter address"
                                        className="form-control"
                                        validators={{
                                            required,
                                            minLength: minLength(5),
                                            maxLength: maxLength(50),                                            
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".address"
                                        show="touched"
                                        component="div"
                                        messages={{
                                            required: 'Required',
                                            minLength: 'Must be at least 5 characters',
                                            maxLength: 'Must be 50 characters or less',                                           
                                        }}
                                    />
                                </Col>
                            </Row> 
                            <Row className="form-group">                      
                                <Col md={4}>
                                    <Label htmlFor="city">City</Label>
                                    <Control.text model=".city" id="city" name="city"
                                        placeholder="Enter city"
                                        className="form-control"
                                        validators={{
                                            required,
                                            minLength: minLength(3),
                                            maxLength: maxLength(25),                                            
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".city"
                                        show="touched"
                                        component="div"
                                        messages={{
                                            required: 'Required',
                                            minLength: 'Must be at least 3 characters',
                                            maxLength: 'Must be 25 characters or less',                                           
                                        }}
                                    />
                                </Col>                                                             
                                <Col md={5}>
                                    <Label id='fixedStateLabel' htmlFor="state">State</Label>
                                    <Control.select model=".state" id="state" name="state"                                       
                                        placeholder="Enter state"
                                        className="form-control"                                    
                                        validators={{
                                            required                                          
                                        }}
                                    >
                                        <option value="">Select state</option>
                                        <option value="AL">Alabama</option>
                                        <option value="AK">Alaska</option>
                                        <option value="AZ">Arizona</option>
                                        <option value="AR">Arkansas</option>
                                        <option value="CA">California</option>
                                        <option value="CO">Colorado</option>
                                        <option value="CT">Connecticut</option>
                                        <option value="DE">Delaware</option>
                                        <option value="DC">District Of Columbia</option>
                                        <option value="FL">Florida</option>
                                        <option value="GA">Georgia</option>
                                        <option value="HI">Hawaii</option>
                                        <option value="ID">Idaho</option>
                                        <option value="IL">Illinois</option>
                                        <option value="IN">Indiana</option>
                                        <option value="IA">Iowa</option>
                                        <option value="KS">Kansas</option>
                                        <option value="KY">Kentucky</option>
                                        <option value="LA">Louisiana</option>
                                        <option value="ME">Maine</option>
                                        <option value="MD">Maryland</option>
                                        <option value="MA">Massachusetts</option>
                                        <option value="MI">Michigan</option>
                                        <option value="MN">Minnesota</option>
                                        <option value="MS">Mississippi</option>
                                        <option value="MO">Missouri</option>
                                        <option value="MT">Montana</option>
                                        <option value="NE">Nebraska</option>
                                        <option value="NV">Nevada</option>
                                        <option value="NH">New Hampshire</option>
                                        <option value="NJ">New Jersey</option>
                                        <option value="NM">New Mexico</option>
                                        <option value="NY">New York</option>
                                        <option value="NC">North Carolina</option>
                                        <option value="ND">North Dakota</option>
                                        <option value="OH">Ohio</option>
                                        <option value="OK">Oklahoma</option>
                                        <option value="OR">Oregon</option>
                                        <option value="PA">Pennsylvania</option>
                                        <option value="RI">Rhode Island</option>
                                        <option value="SC">South Carolina</option>
                                        <option value="SD">South Dakota</option>
                                        <option value="TN">Tennessee</option>
                                        <option value="TX">Texas</option>
                                        <option value="UT">Utah</option>
                                        <option value="VT">Vermont</option>
                                        <option value="VA">Virginia</option>
                                        <option value="WA">Washington</option>
                                        <option value="WV">West Virginia</option>
                                        <option value="WI">Wisconsin</option>
                                        <option value="WY">Wyoming</option>
                                    </Control.select>                                    
                                    <Errors
                                        className="text-danger"
                                        model=".state"
                                        show="touched"
                                        component="div"
                                        messages={{
                                            required: 'Required'                                           
                                        }}
                                    /> 
                                </Col>
                                <Col md={3}>
                                    <Label id='fixedZipLabel' htmlFor="zip">Zip</Label>
                                    <Control.text model=".zip" id="zip" name="zip"
                                        placeholder="Enter zip"
                                        className="form-control"
                                        validators={{
                                            required,
                                            minLength: minLength(5),
                                            maxLength: maxLength(5),                                            
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".zip"
                                        show="touched"
                                        component="div"
                                        messages={{
                                            required: 'Required',
                                            minLength: 'Must be at least 5 characters',
                                            maxLength: 'Must be 5 characters or less',                                           
                                        }}
                                    />
                                </Col>
                            </Row>   
                            <Row className="form-group">
                                <Label htmlFor="phone" md={4}>Phone</Label>
                                <Col md={12}>
                                    <Control.text model=".phone" id="phone" name="phone"
                                        placeholder="Enter phone number"
                                        className="form-control"
                                        validators={{
                                            required,
                                            minLength: minLength(10),
                                            maxLength: maxLength(14),                                            
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".phone"
                                        show="touched"
                                        component="div"
                                        messages={{
                                            required: 'Required',
                                            minLength: 'Must be at least 10 characters',
                                            maxLength: 'Must be 14 characters or less',                                           
                                        }}
                                    />
                                </Col>
                            </Row>                     
                            <Row className="form-group">
                                <Label htmlFor="email" md={4}>Email</Label>
                                <Col md={12}>
                                    <Control.text model=".email" id="email" name="email"
                                        placeholder="Enter email address"
                                        className="form-control"
                                        validators={{
                                            required,
                                            validEmail
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".email"
                                        show="touched"
                                        component="div"
                                        messages={{
                                            required: 'Required',
                                            validEmail: 'Invalid email address'
                                        }}
                                    />
                                </Col>
                            </Row>                         
                            <Row className="form-group">
                                <Col md={{size: 12, offset: 0}}>
                                    <Button type="submit" color="primary">
                                        Send site visit request 
                                    </Button>
                                </Col>
                            </Row>
                        </LocalForm>
                    </ModalBody>               
                </Modal>
                <Modal className="modal-dialog modal-lg" id="locateUs" isOpen={this.state.isModal3Open} toggle={this.state.toggle3Modal}>
                    <ModalHeader toggle={this.toggleModal3}>
                        Locate Us!
                    </ModalHeader>
                    <ModalBody>
                        <div className="container-fluid">
                            <div row>
                                <div col>
                                        <LocateUs />
                                </div>
                            </div>                    
                        </div>
                    </ModalBody>               
                </Modal>
                </Jumbotron>
                <Navbar dark sticky="top" expand="md">
                    <div className="container">                        
                        <NavbarToggler onClick={this.toggleNav} />
                        <Collapse isOpen={this.state.isNavOpen} navbar>
                            <Nav navbar>
                                <NavItem>
                                    <NavLink className="nav-link" to="/home">
                                        <i className="fa fa-home fa-lg" /> Home
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className="nav-link" to="/services">
                                        <i className="fa fa-list fa-lg" /> Services
                                    </NavLink>
                                </NavItem>                                
                                <NavItem>                                    
                                    <Link className="nav-link" to="#" onClick={this.callUs}>
                                        <i className="fa fa-phone" /> Call Us
                                    </Link>
                                </NavItem>
                                <NavItem>                                    
                                    <Link className="nav-link" to="#" onClick={this.toggleModal3}>
                                        <i className="fa fa-info fa-lg" /> Locate Us
                                    </Link>
                                </NavItem>
                            </Nav>
                        </Collapse>
                    </div>
                </Navbar>
            </React.Fragment>
        );
    }
}

export default Header;